
export default function AboutData() {
    return {
        title: "What is Disability Insurance?",
        content: 'These insurance policies are designed to help replace a portion of income lost because the insured is unable to work for an extended period of time due to an illness or injury. The policies and benefits usually expire at age 65-70 depending on the carrier. This type of policy is bought on an individual basis.',
    }
}


// WEBPACK FOOTER //
// ./src/components/Common/data/products/disability-insurance/AboutData.js